import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  List,
  Typography,
} from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { AccordionArrowBlue } from 'Images';
import { useEffect, useState } from 'react';
import { Step } from './Step';

interface IAccordionNumberedStepper {
  title: string;
  steps: string[];
  disabledOnDesktop?: boolean;
}

export const AccordionNumberedStepper = ({
  title,
  steps,
  disabledOnDesktop = true,
}: IAccordionNumberedStepper) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isDesktop = useIsDesktop();

  useEffect(() => {
    if (disabledOnDesktop) setIsExpanded(isDesktop);
  }, [isDesktop, disabledOnDesktop]);

  return (
    <Accordion
      sx={{
        boxShadow: 'none',
        borderRadius: '16px',
        '&::before': { display: 'none' },
        '& .Mui-expanded': { borderRadius: '16px 16px 0px 0px' },
        '&.Mui-disabled': { backgroundColor: 'white' },
      }}
      expanded={isExpanded}
      disabled={disabledOnDesktop && isDesktop}
      onClick={
        disabledOnDesktop && isDesktop
          ? undefined
          : () => setIsExpanded(!isExpanded)
      }
    >
      <AccordionSummary
        sx={{
          height: '62px',
          boxShadow: '0px 4px 28px rgba(45, 112, 217, 0.15)',
          borderRadius: '16px',
          backgroundColor: 'white',
          zIndex: 1,
          '&.Mui-disabled': { opacity: 1 },
        }}
        expandIcon={
          (!isDesktop || !disabledOnDesktop) && (
            <Avatar
              src={AccordionArrowBlue}
              alt=''
              sx={{ width: '24px', height: '24px' }}
            />
          )
        }
      >
        <Typography
          fontSize={isDesktop ? '1.125rem' : '1rem'}
          fontWeight='700'
          lineHeight='1.25rem'
          ml={isDesktop ? '24px' : undefined}
          maxWidth={isDesktop ? undefined : '88%'}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        tabIndex={0}
        sx={{
          boxShadow: '0px 4px 28px rgba(45, 112, 217, 0.15)',
          borderRadius: '0px 0px 16px 16px',
          p: 0,
          position: 'relative',
        }}
      >
        <List
          sx={{
            p: isDesktop ? '40px' : '24px',
            gap: '33px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            zIndex: 1,
          }}
        >
          {steps.map((text, index) => (
            <Step number={index + 1} text={text} key={index} />
          ))}
        </List>
        <div
          style={{
            height: isDesktop ? '60%' : '65%',
            borderRight: '1px solid #1752AF',
            position: 'absolute',
            right: isDesktop ? '53px' : '37px',
            top: '58px',
            zIndex: 0,
          }}
        />
      </AccordionDetails>
    </Accordion>
  );
};
